import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { LOGO_URL } from "../components/Navbar";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Bem-vindo(a), ${user.name.split(" ")[0]}!`);
      navigate(params.get("next") || (user.role === "provider" ? "/painel" : user.role === "admin" ? "/admin" : "/app"));
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao entrar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md bg-white rounded-3xl p-8 border border-brand-coral/10 shadow-sm" data-testid="login-page">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="PetMachine Hub" className="h-12 w-auto mx-auto mb-4 rounded-lg" />
          <h1 className="font-heading font-bold text-2xl text-brand-graphite">Que bom te ver de novo!</h1>
          <p className="text-sm text-muted-foreground mt-1">Entre para cuidar dos seus pets</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="voce@email.com" className="mt-1.5" data-testid="login-email-input" />
          </div>
          <div>
            <Label htmlFor="password">Senha</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" className="mt-1.5" data-testid="login-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-brand-coral hover:bg-brand-coralDark text-white rounded-full h-11" data-testid="login-submit-btn">
            {loading ? "Entrando..." : "Entrar"}
          </Button>
        </form>
        <div className="flex items-center gap-3 my-5">
          <div className="h-px bg-border flex-1" /><span className="text-xs text-muted-foreground">ou</span><div className="h-px bg-border flex-1" />
        </div>
        <Button type="button" variant="outline" onClick={googleLogin} className="w-full rounded-full h-11" data-testid="google-login-btn">
          <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.1a7.16 7.16 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/></svg>
          Continuar com Google
        </Button>
        <p className="text-sm text-center text-muted-foreground mt-6">
          Ainda não tem conta? <Link to="/cadastro" className="text-brand-coral font-semibold" data-testid="go-to-register">Cadastre-se grátis</Link>
        </p>
      </div>
    </div>
  );
}
